<div class="video-player-container" [style.width]="width" [style.height]="height">
  <vm-player
    #vimePlayer
    [controls]="controls"
    [autoplay]="autoplay"
    [loop]="loop"
    [muted]="muted"
    [playsinline]="true"
    (vmPlaybackReady)="onPlayerReady()"
    (vmError)="onError($event)"
  >
    <vm-video [poster]="poster" [preload]="preload">
      <source [src]="videoUrl" [type]="getVideoType()" />
    </vm-video>
  </vm-player>
</div>
